import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import classes from './merge-conflict-modal.module.scss';

type Props = {
  hasPercentDiscount: boolean;
  hasPercentTip: boolean;
  isLoading: boolean;
  isManager: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const MergeConflictModalComponent: React.FC<Props> = ({
  hasPercentDiscount,
  hasPercentTip,
  isLoading,
  isManager,
  onConfirm,
  onCancel,
}) => {
  const both = hasPercentDiscount && hasPercentTip;
  const subject = both ? 'הנחה וטיפ מתמשכים' : hasPercentDiscount ? 'הנחה מתמשכת' : 'טיפ מתמשך';

  if (!isManager) {
    return (
      <div className={classes.overlay} role="dialog" aria-modal="true" dir="rtl">
        <div className={classes.modal}>
          <header className={`${classes.header} ${classes.headerPlain}`}>
            <span className={classes.closeButtonSpacer} aria-hidden="true" />
            <span className={classes.title}>לא ניתן למזג</span>
            <button type="button" className={classes.closeButton} onClick={onCancel} aria-label="סגור" data-testid="merge-conflict-close">
              <FontAwesomeIcon icon={faXmark as IconProp} />
            </button>
          </header>

          <div className={classes.body}>
            <p className={classes.line}>{`קיימת ${subject} על אחד השולחנות`}</p>
            <p className={classes.hint}>על מנת לבטל את ההנחה יש לפנות למנהל</p>
          </div>
        </div>
      </div>
    );
  }

  const btnLabel = isLoading
    ? 'מסיר...'
    : both
      ? 'הסר טיפ והנחה'
      : hasPercentDiscount
        ? 'הסר הנחה'
        : 'הסר טיפ';

  return (
    <div className={classes.overlay} role="dialog" aria-modal="true" dir="rtl">
      <div className={classes.modal}>
        <header className={classes.header}>
          <span className={classes.title}>לא ניתן למזג</span>
        </header>

        <div className={classes.body}>
          <p className={classes.line}>{`קיימת ${subject} על אחד השולחנות`}</p>
          <p className={classes.hint}>לחץ על הסר כדי להמשיך במיזוג</p>
        </div>

        <footer className={classes.footer}>
          <button type="button" className={`${classes.btn} ${classes.btnCancel}`} onClick={onCancel} disabled={isLoading} data-testid="merge-conflict-cancel">
            ביטול
          </button>
          <button type="button" className={`${classes.btn} ${classes.btnRemove}`} onClick={onConfirm} disabled={isLoading} data-testid="merge-conflict-confirm">
            {btnLabel}
          </button>
        </footer>
      </div>
    </div>
  );
};

export const MergeConflictModal = React.memo(MergeConflictModalComponent);
